import './thefifth3insta/style';
import FormStructure from './thefifth3insta/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js